/*eslint-disable */
export default {
	created(el, binding, vNode) {
		let value = binding.value;
		if (vNode.context.isNotEmpty(value)) {
			let routeMeta = vNode.context.$route.meta;
			if (routeMeta.permission && routeMeta.permission.length > 0) {
				let permissionList = routeMeta.permission.map(item => item.permission);
				if (permissionList.indexOf(value) === -1) {
					el.remove();
				}
			} else {
				el.remove();
			}
		}
	},
};